module.exports = __webpack_public_path__ + "static/media/girl1.95193ea8.jpg";